import {type DateView} from '@mui/x-date-pickers';

/**
 * Oreder of views used in date picker.
 *
 * Note that the ordering is important.
 * When clicking the date, the first view will open
 * and after selecting value the next view will open.
 */
export const dateViewsOrder: readonly DateView[] = ['year', 'month', 'day'] as const;
